import { call, put } from "redux-saga/effects";
import { setUserFilterCount } from "../../entities/userFilter";
import { requestGetUserFilterCount } from "../requests/userFilter";

export function* handleGetUserFilterCount(_action) {
    try {
        const response = yield call(requestGetUserFilterCount);
        const { data } = response;
        yield put(setUserFilterCount(data));
    } catch (error) {
        console.log(error);
    };
};

